// Services/Users/fetchVerifyEmail.js
import { USERS } from "../../Constants/Endpoints";
import { ApiRequestInterceptor } from "../apiRequest";

const norm = (res) => {
  const statusCode =
    res?.statusCode ?? res?.code ?? res?.status ?? res?.body?.statusCode ?? null;

  const message =
    res?.message ??
    res?.body?.message ??
    res?.body?.error ??
    (statusCode === 200 ? "Correo verificado" : "Error");

  const data = res?.data ?? res?.body?.data ?? null;

  return { statusCode, message, data, raw: res };
};

export const fetchVerifyEmail = async ({ email, otp }) => {
  const method = "POST";
  const res = await ApiRequestInterceptor(USERS.verifyEmail, method, { email, otp });
  const { statusCode, message, data, raw } = norm(res);

  switch (statusCode) {
    case 200:
      return { statusCode, message, data, ...raw };
    case 400: {
      // Backend puede devolver: "No hay OTP pendiente" | "OTP expirado" | "Código incorrecto"
      if (/expirado/i.test(message)) throw new Error("El código ha expirado");
      if (/no hay otp pendiente/i.test(message)) throw new Error("No hay un código pendiente, solicita uno nuevo");
      if (/incorrecto/i.test(message)) throw new Error("Código incorrecto");
      throw new Error(message || "Código incorrecto o inválido");
    }
    case 429:
      throw new Error("Demasiados intentos. Intenta más tarde.");
    default:
      throw new Error(message || "Error al verificar el correo electrónico");
  }
};